export default __webpack_public_path__ + "static/media/background_device.a8a88310.webp";